<template>
  <div id="rm-order-details-view" class="vx-row" >
    <div class="vx-col w-full">
      <vx-card v-if="dataLoaded" :title="orderDetails.purchase_order_code">
        <template slot="actions">
          <div class="flex">
            <div class="flex">
              <vs-button v-can="'view-order'" @click="onClickPoPdf()" class="ml-2" color="dark" type="border" >Purchase Order PDF</vs-button>
              <vs-button  @click="onClickBack" class="ml-2" color="primary" type="filled">Back to orders</vs-button>
            </div>
          </div>
        </template>

        <div class="vx-row md:mb-3 mt-8">
          <div class="vx-col md:w-1/3 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="UserIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">Supplier</h5>
                    {{orderDetails.supplier}}
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="UserCheckIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Order By</h5>
                    {{orderDetails.staff}}
                  </span>
              </vs-col>
            </vs-row>
          </div>

          <div class="vx-col md:w-1/3 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="CalendarIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Order Date</h5>
                    {{__dateTimeFormatter(orderDetails.created_at)}}
                  </span>
              </vs-col>
            </vs-row>
          </div>
<!--          <div class="vx-col md:w-1/4 w-full">-->
<!--            <vs-row vs-type="flex">-->
<!--              <vs-col-->
<!--                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">-->
<!--                <feather-icon icon="RefreshCwIcon" class="text-success cursor-pointer"/>-->
<!--              </vs-col>-->
<!--              <vs-col-->
<!--                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">-->
<!--                  <span class="text-md break-all">-->
<!--                    <h5 class="mb-2">Order Status</h5>-->
<!--                      <vs-chip style="border-radius: 0" class="text-center" transparent-->
<!--                               :color="orderDetails.is_item_status_handled_individually ? 'dark' : ProductOrderStatusColorFactory()">-->
<!--                        {{ orderDetails.is_item_status_handled_individually ? 'PO Ungrouped' : orderDetails.status.name }}-->
<!--                      </vs-chip>-->
<!--                  </span>-->
<!--              </vs-col>-->
<!--            </vs-row>-->
<!--          </div>-->
        </div>
        <div class="vx-row md:mb-3 mt-16">
          <div class="vx-col md:w-1/3 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="MapPinIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">Address</h5>
                    {{orderDetails.line1}} <br v-if="orderDetails.line1">
                    {{orderDetails.line2}} <br v-if="orderDetails.line2">
                    {{orderDetails.line3}} <br v-if="orderDetails.line3">
                    {{orderDetails.town_state}} <br>
                    {{orderDetails.post_code}} <br>
                    {{orderDetails.country}} <br>
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="TruckIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Delivery Instructions</h5>
                    {{orderDetails.delivery_instruction || 'N/A'}}
                  </span>
              </vs-col>
            </vs-row>
          </div>

          <div class="vx-col md:w-1/3 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="InfoIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Notes</h5>
                    {{orderDetails.note || 'N/A'}}
                  </span>
              </vs-col>
            </vs-row>
          </div>

<!--          <div class="vx-col md:w-1/4 w-full" v-if="orderDetails.raw_material_items.length > 1">-->
<!--            <vs-row vs-type="flex">-->
<!--              <vs-col-->
<!--                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">-->
<!--                <feather-icon icon="SettingsIcon" class="text-success cursor-pointer"/>-->
<!--              </vs-col>-->
<!--              <vs-col-->
<!--                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">-->
<!--                  <span class="text-md break-word">-->
<!--                    <h5 class="mb-2">Do you want to handle each item on this order independently? <br>-->
<!--                    <span class="text-danger text-sm">( If not this <span class="font-bold">PO</span> will be process as a multi-product batch )</span></h5>-->
<!--                    <vs-switch :disabled="orderDetails.raw_material_items.length === 1" v-on:input="onChangeOrderStatusHandle()" v-model="orderDetails.is_item_status_handled_individually" />-->
<!--                  </span>-->
<!--              </vs-col>-->
<!--            </vs-row>-->
<!--          </div>-->

        </div>

        <div class="vx-row" v-if="orderDetails.raw_material_items.length === 1
        && ['Pending', 'Accepted', 'Pending Dispatch'].includes(orderDetails.raw_material_items[0].item_status) && $can('edit-order')
        ">
          <div class="vx-col w-full">
            <div class="flex float-right">
              <vs-dropdown>

                <a class="flex items-center" href="#" v-if="orderDetails.status.name !== 'All Received'">
                  Order Status
                  <i class="material-icons"> expand_more </i>
                </a>

                <vs-dropdown-menu class="w-64">

                  <vs-dropdown-item
                    v-for="status in raw_material_order_statuses"
                    v-bind:key="status.slug"
                    v-if="(status.before_status.includes(orderDetails.status.name) || orderDetails.raw_material_items.map((n) => n.item_status).includes(status.item_status)) && checkIfPartialAndOneItem(status.is_partial_status) && status.is_visible"
                    @click="onClickStatusChangeConfirm(orderDetails.id, status.slug)">
                    {{status.name}}
                  </vs-dropdown-item>

                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
        </div>

        <div class="vx-row my-8">
          <div class="vx-col w-full">
            <product-order-table v-bind:id="orderDetails.id" v-bind:items="orderDetails.raw_material_items"/>
          </div>
        </div>

      </vx-card>
    </div>
    <PartialItemsStatusChangePopUp ref="partialItemsStatusChangePopUp"/>
    <RmOrderPurchaseOrderPdfPopUp  ref="rmOrderPurchaseOrderPdfPopUp"/>
  </div>
</template>

<script>
  import ProductOrderTable from './ProductOrderTable'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const TradingRepository = RepositoryFactory.get('trading')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {raw_material_order_statuses} from '@/constants/statuses'
  import PartialItemsStatusChangePopUp from "@/components/popups/rm-orders/PartialItemsStatusChangePopUp";
  import RmOrderPurchaseOrderPdfPopUp from "@/components/popups/rm-orders/RmOrderPurchaseOrderPdfPopUp";


  export default {
    name: "RmOrderDetailsView",
    components: {
      RmOrderPurchaseOrderPdfPopUp,
      ProductOrderTable,
      PartialItemsStatusChangePopUp
    },
    data: function() {
      return {
        orderDetails: {},
        id: '',
        dataLoaded: false,
        raw_material_order_statuses: raw_material_order_statuses
      }
    },
    mixins : [ SuccessMessage, ErrorMessages],
    async mounted() {
      this.id = this.$route.params.id
      await this.getRmOrderDetails()
    },
    methods: {
      onClickBack() {
        // this.$emit('back')
        this.$router.push({path: `/pages/trading-summary/rm-orders`})
      },
      async refreshData () {
        this.getProductOrderList()
      },
      async backOnDetailsView() {
        this.is_on_details_view = false
        this.getProductOrderList()
      },
      async onClickStatusChangeConfirm(id, status) {
        if (['part_accepted', 'part_dispatched'].includes(status)) {
          await this.$refs.partialItemsStatusChangePopUp.openPopup(id, status, this.orderDetails.raw_material_items)
        } else {
          this.$vs.dialog({
            type: 'confirm',
            color: 'primary',
            title: 'Confirm',
            text: 'Are you sure you want to make this change?',
            accept: this.onChangeSampleOrderStatus,
            parameters: [id, status]
          })
        }
      },
      async onChangeSampleOrderStatus(params){
        await this.$vs.loading({
          container: '#rm-order-details-view',
          scale: 0.45
        })
        try {
          await TradingRepository.statusChangeRmOrder(params[0], params[1])
          this.showSuccessMessage('Status change successfully!')
          await this.getRmOrderDetails()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#rm-order-details-view > .con-vs-loading')
      },
      async getRmOrderDetails() {
        await this.$vs.loading({
          container: '#rm-order-details-view',
          scale: 0.45
        })
        try {
          const {data} = (await TradingRepository.getRmOrderDetails(this.id)).data
          this.orderDetails = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#rm-order-details-view > .con-vs-loading')
        this.dataLoaded= true
      },
      async onClickPoPdf() {
        await this.$refs.rmOrderPurchaseOrderPdfPopUp.openPopup(this.id)
      },
      async onClickProductOrderUpdate () {
        await this.$refs.updateRmOrderPopUp.openPopup(this.id)
      },
      async getProductOrderList() {
        await this.getRmOrderDetails()
      },
      /**
       * @return {string}
       */
      ProductOrderStatusColorFactory() {
        let selected_status = this.raw_material_order_statuses.find((n) => n.name === this.orderDetails.status.name)
        return selected_status ?  selected_status.color : 'dark'
      },
      async onChangeOrderStatusHandle () {
        await this.$vs.loading({
          container: '#rm-order-details-view',
          scale: 0.45
        })
        try {
          await TradingRepository.changeRmOrderHandleType(this.id)
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#rm-order-details-view > .con-vs-loading')
      },
      checkIfPartialAndOneItem(is_partial_status) {
        return !(is_partial_status && this.orderDetails.raw_material_items.length === 1)
      }
    }
  }
</script>

<style scoped>
  /* .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  } */

</style>
